import Arrow from "@/common/icons/arrow"
import Block from "@/components/wrappers/block"
import Image from "next/image"
import { useEffect, useRef, useState } from "react"
import { useTemplate } from "@/lib/helpers/template"
import { Navigation } from "swiper/modules"
import "swiper/css/bundle"
import { Swiper, SwiperSlide } from "swiper/react"
import styles from "./image-slider.module.css"
import classNames from "classnames"

export default function ImageSlider({ block }) {
  const { attrs } = block
  const template = useTemplate()

  const totalSlides = attrs.items.length
  const prevRef = useRef(null)
  const nextRef = useRef(null)
  const defaultSlidePosition = {
    isFirst: true,
    isLast: false
  }

  const [slidePosition, setSlidePosition] = useState(defaultSlidePosition)
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  if (totalSlides === 0) {
    return null
  }

  const settings = {
    className: "relative",
    slidesPerView: "auto",
    observer: "true",
    watchSlidesProgress: true,
    watchslidesvisibility: "true",
    centeredSlides: true,
    spaceBetween: 40,
    navigation: {
      nextEl: ".swiper-nav-next",
      prevEl: ".swiper-nav-prev"
    },
    onBeforeInit: (swiper) => {
      swiper.params.navigation.prevEl = prevRef.current
      swiper.params.navigation.nextEl = nextRef.current
      swiper.navigation.update()
    },
    onSlideChange: (swiper) => {
      setSlidePosition({
        isFirst: swiper.isBeginning,
        isLast: swiper.isEnd
      })
    }
  }

  return (
    <Block
      block={block}
      className={classNames([
        styles.wrapper,
        {
          "image-slider": true,
          "no-print": true,
          [attrs.size]: true
        }
      ])}
      gap={template === "article" ? "content" : "normal"}
      width="bleed">
      {mounted && (
        <Swiper {...settings} modules={[Navigation]}>
          {attrs.items.map((item, index) => {
            const { media } = item
            const key = "image-slide-" + index
            const indexText = "Bild " + (index + 1) + " av " + totalSlides
            return (
              <SwiperSlide className="swiper-slide" key={key}>
                <figure>
                  <Image
                    alt={media.alt}
                    src={media.url}
                    sizes={media.sizes}
                    width={media.width}
                    height={media.height}
                  />
                </figure>
                <div className="caption">
                  <strong>{indexText}</strong>
                  <div dangerouslySetInnerHTML={{ __html: item.text }} />
                  {media.credit && (
                    <span className="credit">
                      {media.type}: {media.credit}
                    </span>
                  )}
                </div>
              </SwiperSlide>
            )
          })}
          <div className="button-container no-print">
            <button
              aria-label="Föregående"
              className={classNames("nav-button prev swiper-nav-prev", {
                "is-dim": slidePosition.isFirst
              })}
              ref={prevRef}>
              <Arrow />
            </button>
            <button
              aria-label="Nästa"
              className={classNames("nav-button next swiper-nav-next", {
                "is-dim": slidePosition.isLast
              })}
              ref={nextRef}>
              <Arrow />
            </button>
          </div>
        </Swiper>
      )}
    </Block>
  )
}
